export default __webpack_public_path__ + "static/media/product-02.befb5b6e.jpg";